<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class="" cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 100px"
        class="term_service"
      >
        <h1 style='text-align:center'>User Referral Program</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <h2>Introduction</h2>
        <p>
          Our goal is to build the best Connected Oral Care products and to help
          build better brushing habits that help make happier, healthier smiles
          for all! Share your excitement and experience with others!
        </p>

        <p>
          The program outlined here is for end-user only. If you are a dental professional, please email us at <a href='mailto:support@candibell.com'>support@candibell.com</a> for our professional referral program.
        </p>

        <h2>How to earn</h2>
        <p>
          Each member of the Truthbrush community (that has an active Truthbrush
          account and device) has a unique referral link that’s easy to share.
          Your referral link becomes active after you’ve created your Truthbrush
          account via the app and made a Truthbrush purchase. Simply send out
          your referral link via text, email, or social media—whichever you
          prefer and your friend automatically receives a discount on their
          first purchase. Once your friend completes the checkout process,
          you’ll also receive a Referral Reward to your Truthbrush account.
        </p>

        <h2>How to redeem</h2>
        <p>
          Once you have 3 referrals, you can convert your rewards into $25 cash!
          Just email <a href='mailto:support@candibell.com'>support@candibell.com</a> & we will send your Reward via Venmo,
          Zella or Paypal!
        </p>

        <h2>Share smiles not spam!</h2>
        <p>
          Tell your friends and family about Truthbrush via email, messaging,
          social media, youTube and other sites. Please do not Advertise, Spam,
          Send misleading or annoying information. Do not pay or offer
          incentives for use of your link. We cannot cover every potential
          misuse of this program; nor will we try to, but we do promise to be
          fair & reasonable.
        </p>
        <p>
          You can confirm who signed up with your referral link, and which
          referrals you’ve received credit from, by logging in and viewing your
          Refer page.
        </p>

        <h2>Additional info</h2>
        <p>
          We introduce programs such as these in good faith and expect the same
          good faith in return.
        </p>
        <ul>
          <li>
            Must be 18 years old to be eligible for benefits/rewards. Rewards
            are not transferable.
          </li>
          <li>Minimal $30 purchase for each referral</li>
          <li>
            Neither the referrer nor the buyer may be a customer facing
            employee, legal representative or partner of Truthbrush or any
            affiliate of Truthbrush. Nothing in the Referral Program shall be
            deemed to create any kind of relationship between the referrer and
            Truthbrush. The referrer has no authority to represent or bind
            Truthbrush
          </li>
          <li>Referrals can not be added after an order has been placed.</li>
          <li>Referral offers can not be combined with any other offers.</li>
          <li>
            We reserve the right to change the conditions of this offer at any
            time.
          </li>
          <li>
            Participation in the referral program is subject to review and can
            be revoked at any time for any reason.
          </li>
          <li>
            Program and awards are conditional on and subject to local laws and
            regulations.
          </li>
          <li>
            The customer is responsible for all taxes and local requirements and
            fees.
          </li>
          <li>
            You can earn referral rewards of up to $599 in each calendar
            year—this is due to US tax regulations on this type of credit. Once
            you reach that limit, new clients who sign up with your link will
            continue being added to your referrals list and they will still
            receive credit at signup as noted on your referrals page. You’ll
            start earning credit again on January 1st of the next calendar year
            for new clients who sign up using your link on that day or later.
          </li>
          <li>
            Referral awards are valid for 180 days. Accounts with no activities
            for 180 days will be deleted and all associated Referral awards will
            be deleted.
          </li>
        </ul>

      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>